// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-video-player[data-v-d32a10ec]{position:relative;width:100%;height:100%}.background-video-player__player[data-v-d32a10ec]{position:absolute;inset:0;z-index:0}.background-video-player__backdrop[data-v-d32a10ec]{position:absolute;inset:0;z-index:1;transition:opacity .5s ease}.background-video-player__backdrop--hidden[data-v-d32a10ec]{opacity:0;pointer-events:none}", ""]);
// Exports
module.exports = exports;
